import useApiUrl from '../../framework/hooks/useApiUrlHook';

export default function TeamItem({ teamMember, active }) {
    const apiUrl = useApiUrl();

    return (
        <a href={`medemerkers/${teamMember.url}`} className={`team-wrap ${active ? 'active' : ''}`}>
            <div className="thumb">
                <img
                    src={`${apiUrl}/img/extern/ratio/www.bandwerk.nl/medewerkers/orig/609/813/100/${teamMember.image}`}
                    alt="team"
                />
            </div>
            <div className="signe"> {teamMember.functie} </div>
            <div className="title-1"> {teamMember.volledigenaam} </div>
            <div className="title-2"> {teamMember.voornaam} </div>
        </a>
    );
}
